<script lang="ts" setup>
import { appIcons } from "#composables/use-icons";
import type { Season } from "#modules/season/season.types";
import { createGetElId } from "#utilities/element";

export interface SeasonSelectDialogProps {
  seasonId: string | undefined;
  seasons: Season[];
}

const props = defineProps<SeasonSelectDialogProps>();

defineEmits<{
  // eslint-disable-next-line @typescript-eslint/prefer-function-type
  (e: "select", season: Season): void;
}>();

const openModel = defineModel<boolean>();

/** Get HTML element ID (with shared component prefix) */
const getElId = createGetElId("season-selection-dialog");

const getIsSeasonCurrent = (season: Season) => season.id === props.seasonId;
</script>

<template>
  <VDialog v-model="openModel" max-width="400" v-bind="$attrs">
    <VCard>
      <VCardTitle>Change Season</VCardTitle>
      <VCardText class="py-0 pb-1 px-4 overflow-y-auto">
        <VList>
          <VListItem
            v-for="season in seasons"
            :id="getElId('season-list-item', season.id)"
            :key="season.id"
            :active="getIsSeasonCurrent(season)"
            :append-icon="getIsSeasonCurrent(season) ? appIcons.mdiCheckCircle : undefined"
            color="primary"
            rounded
            @click="$emit('select', season)"
          >
            <VListItemTitle :class="{ 'font-weight-bold': getIsSeasonCurrent(season) }">
              {{ season.name }}
            </VListItemTitle>
          </VListItem>
        </VList>
      </VCardText>
      <VCardActions>
        <ActionBar right>
          <VBtn :id="getElId('actions-close-btn')" @click="openModel = false">Close</VBtn>
        </ActionBar>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
